import React, { useState } from "react";
import db from "../../firebase";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import parse from "html-react-parser";
import "./PostsStyle/AnswerItem.css";

import EditPostModal from "./EditPostModal";

function AnswerItem({
	answer,
	answerId,
	answerQuestionId,
	questionId,
	timestamp,
	user,
}) {
	const [anchorEl, setAnchorEl] = useState(null);
	const [openModal, setOpenModal] = useState(false);

	const isMenuOpen = Boolean(anchorEl);

	const handleDeletePost = (answerId) => {
		if (user) {
			db.collection("questions")
				.doc(questionId)
				.collection("answer")
				.doc(answerId)
				.delete();
		}

		setAnchorEl(null);
	};

	const handleEditPost = () => {
		setOpenModal(true);
		setAnchorEl(null);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleAnswerMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const answerMenuId = "primary-answer-account-menu";
	const answerRenderMenu = (answerId) => (
		<Menu
			anchorEl={anchorEl}
			key={answerId}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			id={answerMenuId}
			keepMounted
			transformOrigin={{ vertical: "top", horizontal: "right" }}
			open={isMenuOpen}
			onClose={handleMenuClose}
		>
			<MenuItem onClick={handleMenuClose} onClick={handleEditPost}>
				Edit
			</MenuItem>
			<MenuItem
				onClick={handleMenuClose}
				onClick={() => handleDeletePost(answerId)}
			>
				Delete
			</MenuItem>
		</Menu>
	);

	return (
		<div className="post__answer">
			<p key={answerId} style={{ position: "relative", paddingBottom: "20px" }}>
				{questionId === answerQuestionId ? (
					<span>
						<span
							style={{
								marginTop: "20px",
								color: "black",
								fontSize: "medium",
								fontWeight: "bold",
								display: "flex",
								textDecorationLine: "underline",
								paddingBottom: "10px",
							}}
						>
							{user.displayName ? user.displayName : user.email} answered on{" "}
							{new Date(timestamp?.toDate()).toLocaleString()}
							<br />
							<div className="post__answerMenu">
								<IconButton
									edge="end"
									aria-label="post options"
									aria-controls={answerMenuId}
									aria-haspopup="true"
									onClick={handleAnswerMenuOpen}
									color="inherit"
								>
									<MoreVertIcon />
								</IconButton>
								{answerRenderMenu(answerId)}
							</div>
						</span>

						{parse(answer)}
						<br />
						<span
							style={{
								position: "absolute",
								color: "gray",
								fontSize: "small",
								display: "flex",
								right: "0px",
							}}
						></span>
					</span>
				) : (
					""
				)}
			</p>
			<EditPostModal
				openModal={openModal}
				setOpenModal={setOpenModal}
				answer={answer}
				answerId={answerId}
				answerQuestionId={answerQuestionId}
				questionId={questionId}
				timestamp={timestamp}
				user={user}
			/>
		</div>
	);
}

export default AnswerItem;
